<template>
  <div>
    <div
      class="flex flex-row flex-wrap items-center gap-4 text-center justify-center my-4 px-3 md:px-0 md:max-w-screen-lg mx-auto text-4xl"
    >
      <Icon name="Privacy Primary" class="shrink-0 text-primary w-[1em] h-[1em]" />

      <h1>{{ $t("pages.account.security.title") }}</h1>
      <AccountEmailValidationAlert />
    </div>

    <section class="bg-[#F0FBFB] px-4 lg:px-0 py-10 relative">
      <div class="w-full max-w-[1054px] mx-auto flex flex-row flex-wrap gap-4">
        <div class="bg-white shadow-md rounded-sm px-7 py-6 w-full mx-auto max-w-md">
          <h2 class="text-base text-start">{{ $t("pages.account.security.2fa.title") }}</h2>
          <hr class="my-6" />
          <div class="flex flex-row items-center gap-3 justify-between">
            <span>
              {{ $t("pages.account.security.2fa.status") }}:
              <b>{{ $t("pages.account.security.2fa.on") }}</b>
            </span>
            <CheckboxInput name="status" checked :size="2" variant="switch" />
          </div>

          <p class="p-5 bg-[#D8D8D84D] rounded-md mt-4 text-sm">
            {{ $t("pages.account.security.2fa.note") }}
            <br />
            <NuxtLinkLocale :locale="switchBlogLocale()" to="#" class="text-secondary underline hover:no-underline">
              {{ $t("pages.account.security.2fa.learn_more") }}
            </NuxtLinkLocale>
          </p>
        </div>
      </div>
    </section>

    <section class="px-4 py-7 w-full max-w-[1054px] mx-auto md:mt-15">
      <h2 class="text-2xl font-bold text-start max-w-xl">
        {{ $t("pages.account.security.history.title") }}
      </h2>
      <p class="font-semibold text-lg mt-7 max-w-2xl">
        {{ $t("pages.account.security.history.subtitle") }}
      </p>

      <div class="mt-14">
        <span class="flex md:hidden flex-row items-center text-sm gap-4 mb-2 justify-end">
          {{ $t("pages.account.security.history.mobile_hint") }}
          <Icon name="Filter" :scale="2" />
        </span>
        <Table
          :columns="[
            {
              key: 'date_time',
              label: $t('pages.account.security.table.date_time'),
            },
            {
              key: 'device',
              label: $t('pages.account.security.table.device'),
            },
            {
              key: 'ip_address',
              label: $t('pages.account.security.table.ip_address'),
            },
            {
              key: 'location',
              label: $t('pages.account.security.table.location'),
            },
            {
              key: 'status',
              label: $t('pages.account.security.table.status'),
              class: 'w-fit',
              cellComponent: (row) => {
                if (row.status !== 'Sign Out') return null;
                return DeviceSignout;
              },
            },
          ]"
          :data="data"
          :pagination="{
            page: 1,
            rowsPerPage: 5,
          }"
          class="mx-auto"
        />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import CheckboxInput from "~/components/base/CheckboxInput.vue";
import DeviceSignout from "./components/device-signout.vue";

const data = [
  {
    date_time: "2 April 2024 13:00",
    device: "Firefox 124 on Mac OS X 10",
    ip_address: "95.98.258.253",
    location: "Leidschendam, ZH, Netherlands (Odido Netherlands)",
    status: "Sign Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Sign Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
  {
    date_time: "2 April 2024 13:00",
    device: "Safari X on iPhone XS",
    ip_address: "96.68.818.252",
    location: "Amsterdam, NH, Netherlands (KPN Netherlands)",
    status: "Signed Out",
  },
];
</script>
